import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import HoaNavbar from '../HoaNavbar/HoaNavbar';
import HoaNotification from '../HoaNotification/HoaNotification';
import VHOAVideo from "../../assets/VHOAS.mp4"

const HoaHome = () => {
  return (
    <>
      <div className="relative" id='#hoa-home'>
        <HoaNavbar />

        {/* Main container with responsive layout */}
        <div className="min-h-screen flex flex-col lg:flex-row">

          {/* Left section - Image background with content */}
          <div
            className="relative w-full lg:w-1/2 bg-cover bg-center bg-no-repeat overflow-hidden flex justify-center items-center flex-col min-h-screen lg:h-screen"
            style={{ backgroundImage: "url(" + require("../../assert/img1.png") + ")" }}
          >
            {/* White overlay */}
            <div className="absolute inset-0 bg-white bg-opacity-60 z-[1]"></div>

            {/* Mobile/Tablet content - visible on small and medium screens */}
            <div className="relative z-[2] w-full flex justify-center items-center flex-col text-center px-4 sm:px-6 md:px-8 py-8 lg:hidden">
              <h1 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
                Why Choose Us
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-white mb-6 max-w-md mx-auto leading-relaxed">
                Self-service solution, 100% customizable and fully secure.
              </p>
              <ScrollLink
                to="hoa-contact"
                smooth={true}
                duration={500}
                className="py-3 px-6 sm:py-3.5 sm:px-7 bg-blue-800 text-white no-underline rounded-md shadow-lg cursor-pointer hover:bg-blue-700 active:bg-blue-900 transition-all duration-200 text-sm sm:text-base font-medium mb-6"
              >
                Let's Talk
              </ScrollLink>
              <div className="w-full flex justify-center">
                <video
                  src={VHOAVideo}
                  muted
                  loop
                  playsInline
                  controls
                  className="w-64 h-auto sm:w-72 md:w-80 lg:w-96 max-w-full object-contain rounded-xl shadow-2xl hover:shadow-3xl transform hover:scale-102 transition-all duration-300 ease-in-out bg-gradient-to-br from-blue-50 to-white p-2"
                  style={{ aspectRatio: '16/9' }}
                />
              </div>
            </div>
          </div>

          {/* Right section - Desktop content */}
          <div className="w-full lg:w-1/2 bg-white justify-center items-center flex-col min-h-screen lg:h-screen hidden lg:flex px-8 xl:px-12">
            <div className="w-full max-w-lg xl:max-w-xl flex justify-center items-center flex-col text-center">
              <h1 className="text-4xl xl:text-5xl 2xl:text-6xl font-extrabold text-blue-800 mb-6 leading-tight">
                Why Choose Us
              </h1>
              <p className="text-lg xl:text-xl 2xl:text-2xl font-medium text-blue-800 mb-8 leading-relaxed">
                Self-service solution, 100% customizable and fully secure.
              </p>
              <ScrollLink
                to="hoa-contact"
                smooth={true}
                duration={500}
                className="py-3.5 px-7 xl:py-4 xl:px-8 bg-blue-800 text-white no-underline rounded-md shadow-lg cursor-pointer hover:bg-blue-700 active:bg-blue-900 transition-all duration-200 text-base xl:text-lg font-medium mb-8"
              >
                Let's Talk
              </ScrollLink>
              <div className="w-full flex justify-center">
                <video
                  src={VHOAVideo}
                  muted
                  loop
                  playsInline
                  controls
                  className="w-80 xl:w-96 2xl:w-[32rem] h-auto max-w-full object-contain rounded-2xl shadow-2xl hover:shadow-3xl transform hover:scale-102 transition-all duration-300 ease-in-out bg-gradient-to-br from-blue-50 to-white p-3"
                  style={{ aspectRatio: '16/9' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification component */}
      {/* <div className="fixed bottom-0 left-0 right-0 z-[9999] w-full">
        <HoaNotification />
      </div> */}
    </>
  )
}

export default HoaHome;